import { useState } from "react";
import { FaEye } from "react-icons/fa";

import { closeIcon } from "../../../assetData/icons";
import BackDrop from "../../ui/BackDrop";
import MirageLoader from "../../ui/pageLoader/MirageLoader";

const getExistingImage = (data) =>
  data?.image_url ||
  data?.template_image_url ||
  data?.template_image ||
  data?.image;

const getImageUrl = (image) => {
  if (!image || typeof image !== "string") return "";
  if (/^(https?:|data:|blob:)/i.test(image)) return image;

  const baseUrl = process.env.REACT_APP_API_URL || "";
  return `${baseUrl.replace(/\/$/, "")}/${image.replace(/^\//, "")}`;
};

const UpdateTemplateImage = ({ data, updateHandler, closeHandler }) => {
  const [image, setImage] = useState();
  const [showImage, setShowImage] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const existingImage = getImageUrl(getExistingImage(data));

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!image) return;

    setSubmitting(true);
    await updateHandler(data?.template_id, image);
    setSubmitting(false);
  };

  return (
    <>
      <div className="fixed left-1/2 top-1/2 z-50 w-[95%] max-w-[600px] -translate-x-1/2 -translate-y-1/2 rounded bg-white p-8">
        <h2 className="pb-6 text-2xl font-bold text-neutral-800">
          Update Template Image
        </h2>
        <button
          type="button"
          className="absolute right-8 top-8"
          onClick={closeHandler}
          aria-label="Close"
        >
          <img src={closeIcon} alt="Close" />
        </button>

        <form onSubmit={handleSubmit}>
          <label className="mb-2 block text-base text-[#636363]">
            Template Image*
          </label>
          <div className="flex items-center gap-3">
            <input
              type="file"
              accept="image/*"
              onChange={(event) => setImage(event.target.files?.[0])}
              className="w-full rounded bg-neutral-100 p-2 text-[#636363] focus:outline-none"
              required
            />
            <button
              type="button"
              title={existingImage ? "View existing image" : "No existing image"}
              aria-label="View existing image"
              onClick={() => setShowImage(true)}
              disabled={!existingImage}
              className={`rounded bg-neutral-100 p-3 text-[#636363] ${
                existingImage ? "" : "cursor-not-allowed opacity-50"
              }`}
            >
              <FaEye className="text-xl" />
            </button>
          </div>

          <button
            type="submit"
            disabled={!image || submitting}
            className={`mt-8 w-full rounded border-2 border-pri-clr-orange bg-pri-clr-orange px-8 py-2 font-semibold text-white ${
              !image || submitting ? "opacity-70" : ""
            }`}
          >
            {submitting ? <MirageLoader /> : "SUBMIT"}
          </button>
        </form>
      </div>
      <BackDrop closeHandler={closeHandler} />

      {showImage && (
        <>
          <div className="fixed left-1/2 top-1/2 z-[70] max-h-[85vh] w-[95%] max-w-[900px] -translate-x-1/2 -translate-y-1/2 rounded bg-white p-6">
            <button
              type="button"
              className="absolute right-4 top-4 rounded bg-white p-2 shadow"
              onClick={() => setShowImage(false)}
              aria-label="Close image preview"
            >
              <img src={closeIcon} alt="Close" />
            </button>
            <img
              src={existingImage}
              alt={`Template ${data?.template_id || ""}`}
              className="max-h-[75vh] w-full object-contain"
            />
          </div>
          <BackDrop
            closeHandler={() => setShowImage(false)}
            className="z-[60]"
          />
        </>
      )}
    </>
  );
};

export default UpdateTemplateImage;
